Osano.cm.addEventListener('osano-cm-initialized', function() {
  console.log('osano initialized');
  document.querySelector('.osano-cm-window__info-dialog .osano-cm-info-dialog__info .osano-cm-header').setAttribute('aria-label', 'Storage preferences')
});

// Function to handle the found element
function handleElementFound(element) {

    function getEffectivelyEmptyElements(selector) {
      const elements = document.querySelectorAll(selector);
      const emptyElements = Array.from(elements).filter(element => {
        // Check if the element's trimmed text content is an empty string
        return element.textContent.trim() === "";
      });
      return emptyElements;
    }

    // Example usage:
    setTimeout(() => {
      const allLabels = getEffectivelyEmptyElements('#yotpo-reviews-main-widget label');
      allLabels.forEach(function(label) {
        if (label.classList.contains('yotpo-progress-bar-value-point')) {
          label.setAttribute('aria-label', 'Yotpo progress bar value point')
        }
      });

      const allHeadings = getEffectivelyEmptyElements('#yotpo-reviews-main-widget [role="heading"]');
      allHeadings.forEach(function(heading) {
        if (heading.classList.contains('yotpo-review-title')) {
          heading.setAttribute('aria-label', 'Yotpo review title')
        }
      });

      let searchLabel = element.querySelector('.yotpo-search-label');
      if (searchLabel) {
        searchLabel.setAttribute('aria-label', 'Yotpo search label');
      }
    }, 2000);
}

// Function to check for the target element and disconnect observer if found
function checkForElement(mutationsList, observerReviewWidget) {
    for (const mutation of mutationsList) {
        // Check if nodes were added
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
            for (const node of mutation.addedNodes) {
                // Only interested in actual element nodes, not text or comments
                if (node.nodeType === Node.ELEMENT_NODE) {
                    // Check the node itself for the ID
                    if (node.id === 'yotpo-reviews-main-widget') {
                        handleElementFound(node);
                        observerReviewWidget.disconnect(); // Stop observing once found
                        return;
                    }
                    // Check if the node's descendants contain the element (in case a large subtree was added)
                    const foundElement = node.querySelector('#yotpo-reviews-main-widget');
                    if (foundElement) {
                        handleElementFound(foundElement);
                        observerReviewWidget.disconnect(); // Stop observing once found
                        return;
                    }
                }
            }
        }
    }
}

// Create a new MutationObserver instance
const observerReviewWidget = new MutationObserver(checkForElement);

// Start observing the document body for child list changes
observerReviewWidget.observe(document.body, { childList: true, subtree: true });


document.addEventListener("DOMContentLoaded", function(event) {
  setTimeout(() => {
    const allInputs = document.querySelectorAll('#DoNotSellForm input');
    allInputs.forEach(function(input) {
      if (!input.hasAttribute('id')) {
        let inputName = input.getAttribute('name');
        input.setAttribute('id', inputName);
      }
    });

    let captchaResponse = document.querySelector('textarea[name="h-captcha-response"]');
    if (captchaResponse) {
      captchaResponse.setAttribute('aria-label', 'Captcha response');
    }

  }, 2000);
  
});
